"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderStars = void 0;
var React = require("react");
exports.renderStars = function (rate) {
    var solidCount = Math.floor(rate);
    var remainder = rate - solidCount;
    var halfCount = remainder > 0.3 && remainder < 0.7 ? 1 : 0;
    if (remainder > 0.7) {
        solidCount = solidCount + 1;
    }
    var emptyCount = 5 - solidCount - halfCount;
    return (React.createElement(React.Fragment, null,
        renderSolid(solidCount),
        renderHalf(halfCount),
        renderEmpty(emptyCount)));
};
var renderSolid = function (n) {
    var stars = [];
    for (var i = 0; i < n; i = i + 1) {
        stars.push((React.createElement("div", { key: i, className: "c-homereview__star" })));
    }
    return stars;
};
var renderHalf = function (n) {
    var stars = [];
    for (var i = 0; i < n; i = i + 1) {
        stars.push((React.createElement("div", { key: i, className: "c-homereview__star c-homereview__star--half" })));
    }
    return stars;
};
var renderEmpty = function (n) {
    var stars = [];
    for (var i = 0; i < n; i = i + 1) {
        stars.push((React.createElement("div", { key: i, className: "c-homereview__star c-homereview__star--empty" })));
    }
    return stars;
};
